import React from 'react'
import { Formik } from 'formik'
import * as yup from 'yup'
import { Form, Button } from 'react-bootstrap'
import { useHistory, useLocation } from 'react-router-dom'
import { PropTypes } from 'prop-types'
import AuthService from '../../services/auth.service';

import './login.scss'

const schema = yup.object().shape({
    email: yup
        .string()
        .required('Email is a required field')
        .email('Invalid email '),
    password: yup.string().required('Password is a required field'),
})

const Login = () => {
    const history = useHistory()
    const location = useLocation()

    const submit = (credentials, { setErrors }) => {
        AuthService().login({ username: credentials.email, password: credentials.password })
            .then(() => {
                //redirect to requested route or go to home if it wasn't specified
                const { from } = location.state || { from: { pathname: '/' } }
                history.push(from)
            })
            .catch(err => {
                if (err.response)
                    setErrors({ password: err.response.data })
            })
    }

    return (
        <div className="login-page">
            <h1 className="login-tittle">Sign in</h1>
            <Formik
                validationSchema={schema}
                onSubmit={submit}
                initialValues={{ email: '', password: '' }}
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    errors,
                    dirty,
                    touched,
                }) => (
                        <Form className="login-form" noValidate onSubmit={handleSubmit}>
                            <Form.Group controlId="email">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    className="login-input"
                                    type="text"
                                    name="email"
                                    onBlur={handleBlur}
                                    value={values.email}
                                    onChange={handleChange}
                                    isInvalid={!!errors.email && touched.email}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.email}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group controlId="password">
                                <Form.Label>Password</Form.Label>
                                <Form.Control
                                    className="login-input"
                                    type="password"
                                    name="password"
                                    onBlur={handleBlur}
                                    value={values.password}
                                    onChange={handleChange}
                                    isInvalid={!!errors.password && touched.password}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.password}
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Button
                                className="submit-button"
                                disabled={!dirty || !!errors.email}
                                type="submit">
                                Log in
                            </Button>
                        </Form>
                    )}
            </Formik>
        </div>
    )
}

Login.propTypes = {
    login: PropTypes.func,
}

export default Login;